import React from 'react'
import { withIcon } from '../../withIcon'

function CommentIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 5.625C6.37011 5.625 5.76602 5.87522 5.32062 6.32062C4.87522 6.76602 4.625 7.37011 4.625 8V19.4911L7.55806 16.5581C7.67527 16.4408 7.83424 16.375 8 16.375H17C17.6299 16.375 18.234 16.1248 18.6794 15.6794C19.1248 15.234 19.375 14.6299 19.375 14V8C19.375 7.37011 19.1248 6.76602 18.6794 6.32062C18.234 5.87522 17.6299 5.625 17 5.625H7ZM4.43674 5.43674C5.11656 4.75692 6.03859 4.375 7 4.375H17C17.9614 4.375 18.8834 4.75692 19.5633 5.43674C20.2431 6.11656 20.625 7.03859 20.625 8V14C20.625 14.9614 20.2431 15.8834 19.5633 16.5633C18.8834 17.2431 17.9614 17.625 17 17.625H8.25888L4.44194 21.4419C4.26319 21.6207 3.99437 21.6742 3.76082 21.5774C3.52728 21.4807 3.375 21.2528 3.375 21V8C3.375 7.03859 3.75692 6.11656 4.43674 5.43674ZM7.375 9C7.375 8.65482 7.65482 8.375 8 8.375H16C16.3452 8.375 16.625 8.65482 16.625 9C16.625 9.34518 16.3452 9.625 16 9.625H8C7.65482 9.625 7.375 9.34518 7.375 9ZM7.375 13C7.375 12.6548 7.65482 12.375 8 12.375H14C14.3452 12.375 14.625 12.6548 14.625 13C14.625 13.3452 14.3452 13.625 14 13.625H8C7.65482 13.625 7.375 13.3452 7.375 13Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CommentIcon)
